// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
export { SPLIT_PANEL_MIN_WIDTH, SPLIT_PANEL_MIN_HEIGHT } from './constants';
export { SideSplitPanelDrawer } from './drawer';
export { SplitPanelProvider, SplitPanelProviderProps } from './provider';



// WEBPACK FOOTER //
// /Volumes/src/app-layout/split-panel/index.tsx